
const currencyConverter = (currencyValue) => {
  if (currencyValue !== undefined && currencyValue !== "") {
    if (typeof currencyValue === "string") {
      currencyValue = Number(currencyValue);
    }
    let value = currencyValue.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    return "$" + value.substring(0, value.indexOf(".") + 0);
  }
  return null;
};
export const getPrice = ({listingType, statusPayload, bidCenterData, offerCenterDetail, pdpInitData, propCategory, estimatedOpeningBid,auctionDetails}) => {
  let result = {
    amount: "",
    label: "",
  };
  if (listingType === "AUCN") {
    if (statusPayload?.isActive || statusPayload?.isPact) {
      const hasValidTimer = bidCenterData?.auctionTimeLeft !== null;
    }
    if (bidCenterData?.displayListPriceForAuction === "Y") {
      result.amount = currencyConverter(bidCenterData.listingPrice);
      result.label = "Listing Price";
    } else if (bidCenterData?.currentHighestBid === 0) {
      result.amount = currencyConverter(bidCenterData.startingBidAmount);
      result.label = "Starting Bid";
    } else {
      result.amount = currencyConverter(auctionDetails?.highestBidAmount ? auctionDetails?.highestBidAmount : bidCenterData?.currentHighestBid);
      result.label = "Current Highest Bid";
    }
  } else if (listingType === "TRNL") {
    if (
      offerCenterDetail?.currentHighestOffer !== "0" &&
      offerCenterDetail?.currentHighestOffer !== null
    ) {
      result.amount = currencyConverter(
        offerCenterDetail.currentHighestOffer
      );
      result.label = "Current Highest Offer";
    } else if (offerCenterDetail?.listingPrice) {
      result.amount = currencyConverter(offerCenterDetail.listingPrice);
      result.label = "Listing Price";
    } else {
      result.amount = currencyConverter(
        pdpInitData?.propertySpecialDetails?.listingPrice
      );
      result.label = "Starting Bid";
    }
  } else if (propCategory === "FORECLOSURE") {
    if (estimatedOpeningBid) {
      result.amount = currencyConverter(estimatedOpeningBid);
      result.label = "Estimated Opening Bid";
    } else {
      result.amount = "TBD";
      result.label = "Estimated Opening Bid";
    }
  }
  return result;
};